import { useRef } from 'react';
import ProTermsConditionModal from '@/app/(content)/pro-program/_components/ProTermsConditionModal';
import Icon from '@/components/common/Icon';
import { useLayoutActions } from '../../Providers/LayoutContext';
import useScrollLock from '@/hooks/app/useScrollLock';
import useOutsideClick from '@/hooks/app/useOutsideClick';

const ProProgramTermsModal = () => {
  const { toggleProProgramTerms: onClose } = useLayoutActions();
  const wrapperRef = useRef(null);

  useScrollLock(true, wrapperRef);
  useOutsideClick(wrapperRef, () => {
    onClose();
  });

  return (
    <div
      className="fixed left-0 top-0 bottom-0 right-0 z-[999999] flex justify-center items-center px-5"
      style={{
        background: 'rgba(0,0,0,0.1)',
      }}
    >
      <div ref={wrapperRef} className="bg-[#ffffff] max-w-[630px]  p-[30px] rounded-[5px] relative">
        <div className="w-full relative flex">
          <h3
            className="mx-auto text-[#0C1319] uppercase text-[20px] font-semibold tracking-[0.01em]"
          >
            Terms & Conditions
          </h3>
          <div>
            <Icon
              className="cursor-pointer fill-gray-500 absolute  right-0"
              viewBox="0 0 25 25"
              size={18}
              icon="close"
              onClick={onClose}
            />
          </div>
        </div>

        <div className="text-[14px] text-black font-normal leading-[24px] mt-[30px] tracking-[0.02em] max-h-[480px] overflow-y-scroll [&::-webkit-scrollbar]:w-[6px] [&::-webkit-scrollbar-track]:bg-[#eeeeee] [&::-webkit-scrollbar-thumb]:bg-[#dd5f13]">
          <ProTermsConditionModal />
        </div>
      </div>
    </div>
  );
};

export default ProProgramTermsModal;
